import Swiper from "swiper/swiper-bundle";

export const debounce = function( fn, delay, context ) {
    var timeout;
    return function() {
        var args = arguments;

        context = context || this;

        clearTimeout( timeout );
        timeout = setTimeout( function() {
            timeout = null;
            fn.apply( context, args );
        }, delay );
    };
};

export const math = {
    lerp: (a, b, n) => {
        return (1 - n) * a + n * b
    },
    norm: (value, min, max) => {
        return (value - min) / (max - min)
    },
    clamp: (num, min, max) => Math.min(Math.max(num, min), max),
    map: (value, in_min, in_max, out_min, out_max) => {
        return (value - in_min) * (out_max - out_min) / (in_max - in_min) + out_min
    }
}

export const toRGBA = (d) => {
    const r = Math.round;
    const l = d.length;
    const rgba = {};
    if (d.slice(0, 3).toLowerCase() === 'rgb') {
        d = d.replace(' ', '').split(',');
        rgba[0] = parseInt(d[0].slice(d[3].toLowerCase() === 'a' ? 5 : 4), 10);
        rgba[1] = parseInt(d[1], 10);
        rgba[2] = parseInt(d[2], 10);
        rgba[3] = d[3] ? parseFloat(d[3]) : -1;
    } else {
        if (l < 6) d = parseInt(String(d[1]) + d[1] + d[2] + d[2] + d[3] + d[3] + (l > 4 ? String(d[4]) + d[4] : ''), 16);
        else d = parseInt(d.slice(1), 16);
        rgba[0] = (d >> 16) & 255;
        rgba[1] = (d >> 8) & 255;
        rgba[2] = d & 255;
        rgba[3] = l === 9 || l === 5 ? r((((d >> 24) & 255) / 255) * 10000) / 10000 : -1;
    }
    return rgba;
}

export const colorBlend = (from, to, p = 0.5) => {
    const r = Math.round;
    from = from.trim();
    to = to.trim();
    const b = p < 0;
    p = b ? p * -1 : p;
    const f = toRGBA(from);
    const t = toRGBA(to);
    if (to[0] === 'r') {
        return 'rgb' + (to[3] === 'a' ? 'a(' : '(') +
            r(((t[0] - f[0]) * p) + f[0]) + ',' +
            r(((t[1] - f[1]) * p) + f[1]) + ',' +
            r(((t[2] - f[2]) * p) + f[2]) + (
                f[3] < 0 && t[3] < 0 ? '' : ',' + (
                    f[3] > -1 && t[3] > -1
                        ? r((((t[3] - f[3]) * p) + f[3]) * 10000) / 10000
                        : t[3] < 0 ? f[3] : t[3]
                )
            ) + ')';
    }

    return '#' + (0x100000000 + ((
            f[3] > -1 && t[3] > -1
                ? r((((t[3] - f[3]) * p) + f[3]) * 255)
                : t[3] > -1 ? r(t[3] * 255) : f[3] > -1 ? r(f[3] * 255) : 255
        ) * 0x1000000) +
        (r(((t[0] - f[0]) * p) + f[0]) * 0x10000) +
        (r(((t[1] - f[1]) * p) + f[1]) * 0x100) +
        r(((t[2] - f[2]) * p) + f[2])
    ).toString(16).slice(f[3] > -1 || t[3] > -1 ? 1 : 3);
}

export const mapNumber = (number, inMin, inMax, outMin, outMax) => {
    return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}

export const lerp = (start, end, amt) => {
    return (1 - amt) * start + amt * end
}

export const clamp = (num, min, max) => Math.min(Math.max(num, min), max)

export const norm = (value, min, max) => {
    return (value - min) / (max - min)
}

export const lab2rgb = (lab) => {
    let y = (lab[0] + 16) / 116,
        x = lab[1] / 500 + y,
        z = y - lab[2] / 200,
        r, g, b;

    x = 0.95047 * ((x * x * x > 0.008856) ? x * x * x : (x - 16/116) / 7.787);
    y = 1.00000 * ((y * y * y > 0.008856) ? y * y * y : (y - 16/116) / 7.787);
    z = 1.08883 * ((z * z * z > 0.008856) ? z * z * z : (z - 16/116) / 7.787);

    r = x *  3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y *  1.8758 + z *  0.0415;
    b = x *  0.0557 + y * -0.2040 + z *  1.0570;

    r = (r > 0.0031308) ? (1.055 * Math.pow(r, 1/2.4) - 0.055) : 12.92 * r;
    g = (g > 0.0031308) ? (1.055 * Math.pow(g, 1/2.4) - 0.055) : 12.92 * g;
    b = (b > 0.0031308) ? (1.055 * Math.pow(b, 1/2.4) - 0.055) : 12.92 * b;

    return [Math.max(0, Math.min(1, r)) * 255,
        Math.max(0, Math.min(1, g)) * 255,
        Math.max(0, Math.min(1, b)) * 255]
}

export const rgbToHex = (rgb) => {
    const [r, g, b] = rgb
    return "0x" + ((1 << 24) + (Math.floor(r) << 16) + (Math.floor(g) << 8) + Math.floor(b)).toString(16).slice(1);
}

export const isMobile = () => {
    return window.matchMedia('(max-width: 767px)').matches;
}

export class FPSEstimator {
    constructor() {
        this.frameTimes = [];
        this.lastTimestamp = null;
        this.estimatedFPS = 60; // default value
    }

    startEstimation() {
        this.frameTimes = [];
        this.lastTimestamp = null;
        this._measure();
    }

    _measure(timestamp) {
        if (this.lastTimestamp) {
            this.frameTimes.push(timestamp - this.lastTimestamp);

            if (this.frameTimes.length === 60) {
                // After collecting a second's worth of frame data (assuming 60Hz)
                let averageFrameTime = this.frameTimes.reduce((a, b) => a + b) / this.frameTimes.length;
                this.estimatedFPS = Math.round(1000 / averageFrameTime);
                if (this.callback) {
                    this.callback(this.estimatedFPS);
                }
                return; // stop measuring after we get enough data
            }
        }

        this.lastTimestamp = timestamp;
        requestAnimationFrame(this._measure.bind(this));
    }

    onReady(callback) {
        this.callback = callback;
    }
}

export const capitalizeFirstLetter = (word) => {
    if (!word) return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
}

export const RespSwiper = (selector, pointBreak, options) => {
  const availableMobileSwiperClasses = selector;
  const items = document.querySelectorAll(availableMobileSwiperClasses);

  if (items.length === 0)
    return;

  items.forEach(item => {
    const breakpoint = window.matchMedia("(min-width: " + pointBreak + "px)");

    let mySwiper;

    const breakpointChecker = function () {
      if (breakpoint.matches === true) {
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };

    const enableSwiper = function () {
      mySwiper = new Swiper(item, options);
    };

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  })
};
